<template>
    <div id="F-enter" v-if="adInfo">
      <div class="enter-area" :class="{hasInfo: adInfo.info ? true : false}" @click.stop="goHuichang" v-if="adInfo.timeout">
          <div class="info" v-if="adInfo.info">
              {{adInfo.info}}
          </div>
          <div class="time">
            剩余<span class="black-bg">{{time.days}}</span>天<span class="black-bg">{{time.hours}}</span>时<span class="black-bg">{{time.minutes}}</span>分<span class="black-bg">{{time.seconds}}</span>秒
          </div>
      </div>
      <div class="enter-project" v-if="skuList">
        <div class="enter-list" :style="skuStyle">
          <a :href="item.url" class="enter-item" v-for="item in skuList">
            <div class="enter-img-area">
              <img :src="item.picUrl" />
              <div class="enter-item-status" :class="{'status-on': item.status == 2}">{{getStatus(item)}}</div>
            </div>
            <div class="enter-item-content">
              <p class="enter-item-title">{{item.title}}</p>
              <p class="enter-item-price">秒杀¥{{item.skuPrice}}</p>
              <p class="enter-item-orginPrice">¥{{item.oriPrice}}</p>
            </div>
          </a>
          <a class="enter-more" :href="more" :class="{add: skuList.length > 1}">查看更多</a>
        </div>
      </div>
    </div>
</template>
<style lang="less" scroped>
.enter-area {
    position: relative;
    width:100%;
    height:8rem;
    background: url("../assets/sku_enter_without@2x.png") no-repeat center/cover;
    &.hasInfo {
      background: url("../assets/sku_enter@2x.png") no-repeat center/cover;
    }
    .info {
        position: absolute;
        left:1.5rem;
        bottom:1.2rem;
        color:#fff;
        font-size:1.4rem;
        font-weight:bold;
        &:before {
            content: '';
            width:1.2rem;
            height:1.3rem;
            display: inline-block;
            background: url("../assets/horn_icon.png") no-repeat center/cover;
            margin-right: .2rem;
            vertical-align: -0.17rem;
        }
    }
    .time {
        position: absolute;
        top:1.2rem;
        right:1.2rem;
        color:#fff;
        font-size:.9rem;
        .black-bg {
            font-size: 1rem;
            background: #39025C;
            -webkit-border-radius:.2rem;
            -moz-border-radius:.2rem;
            border-radius:.2rem;
            width:1.6rem;
            height:1.6rem;
            line-height:1.6rem;
            padding:0 .2rem;
            -webkit-box-sizing: border-box;
            -moz-box-sizing: border-box;
            box-sizing: border-box;
            display: inline-block;
            margin:0 .2rem;
        }
    }
}
.enter-project {
  width: 100%;
  box-sizing: border-box;
  padding: 1.5rem;
  overflow: auto;
  background: url(../assets/sku_down.png) top center/37.5rem 23.3rem no-repeat;
  background-color: #9029bf;
  &::-webkit-scrollbar {
    display: none;
  }
  .enter-list {
    display: flex;
    align-items: center;
    .enter-item {
      width: 19rem;
      background: #fff;
      margin-left: 1rem;
      &:first-child {
        margin-left: 0;
      }
      .enter-img-area {
        position: relative;
        img {
          width: 100%;
        }
        .enter-item-status {
          position: absolute;
          border-radius: 2.1rem;
          line-height: 2.1rem;
          font-size: 1.1rem;
          padding: 0 1.1rem;
          background-color: #222;
          color: #fff;
          opacity: 0.9;
          left: 50%;
          bottom: 1rem;
          transform: translate(-50%, 0);
          white-space: nowrap;
          &.status-on {
            background-color: #F0348D;
          }
        }
      }
      .enter-item-content {
        padding: 0.8rem;
        .enter-item-title {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          font-size: 1.3rem;
          line-height: 1.8rem;
          color: #333;
          font-family: PingFangSC-Semibold;
        }
        .enter-item-price {
          font-family: PingFangSC-Semibold;
          font-size: 1.3rem;
          margin-top: 0.4rem;
          line-height: 1.8rem;
          color: #FC3570;
        }
        .enter-item-orginPrice {
          font-size: 1.1rem;
          line-height: 1.5rem;
          color: #999;
          text-decoration: line-through;
        }
      }
    }
    .enter-more {
      width: 3.6rem;
      height: 14rem;
      border-radius: 3.6rem;
      background: #BA3EC5;
      box-sizing: border-box;
      padding: 3rem 1rem;
      font-size: 1.4rem;
      color: #fff;
      margin-left: 11.9rem;
      &.add {
        margin-left: 1.5rem;
      }
    }
  }
}
</style>
<script>
  import fetchjsonp from 'fetch-jsonp'
  import Toast from '@gfe/app-common-toast'
  import countDown from '../tools/countdown.js';

  export default{
    data(){
      return {
        adInfo: null,
        skuList: null,
        more: null,
        time:{
          days:0,
          hours:0,
          minutes:0,
          seconds:0
        }
      }
    },
    props:['config'],
    created() {
      let hostname = location.hostname.indexOf('test') > -1 || location.hostname.indexOf('51ping') > -1 ? 'm.51ping.com' : 'm.dianping.com'
      let url = `//${hostname}/wedding/ajax/m/events/higoubanner.wapi?shopId=${this.config.shopId}&cityId=${this.config.cityId || ''}&productid=${this.config.productid || ''}&goodsid=${this.config.goodsid || ''}`
      fetchjsonp(url).then(res=>res.json()).then(data=>{
        if (data.code == 200) {
          if (data.content.wedHigouSkuBanner) {
            this.adInfo = {
              timeout: data.content.wedHigouSkuBanner.startTime,
              info: data.content.wedHigouSkuBanner.benifitDesc,
              url: data.content.wedHigouSkuBanner.url
            }
            this.more = data.content.wedHigouSkuBanner.more
            this.skuList = data.content.wedHigouSkuBanner.skuList
            this.startTimer();
          }
        } else {
          Toast(data.msg)
        }
      })
    },
    computed: {
      skuStyle() {
        let width = 0;
        if (this.skuList) {
          if (this.skuList.length > 1) {
            width = this.skuList.length * 20 - 1 + 3.6 + 1.5
          } else {
            width = this.skuList.length * 20 - 1 + 3.6 + 11.9
          }
        }
        return {width: width + 'rem'}
      }
    },
    methods:{
      bindScroll() {
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        let h = document.documentElement.clientHeight || document.body.clientHeight;
        let enter = document.querySelector('.enter-area')
        let enter_rect = dom.getBoundingClientRect()
        if (enter_rect.x > 0 && enter_rect.x < w && enter_rect.y > 0 && enter_rect.y < h) {

        }
      },
      getStatus(item) {
        if (item.status == 3) {
          return '已售罄'
        } else if (item.status == 2) {
          return '正在秒杀'
        } else if (item.status == 1) {
          let num = Math.ceil(item.startTime/24/3600/1000)
          if (num > 2) {
            return num + '天后10:00开抢'
          } else {
            if (new Date().getHours() > 10) {
              return '明天10:00开抢'
            } else {
              return '今天10:00开抢'
            }
          }
        }
      },
      startTimer(){
        let timer = this.adInfo.timeout / 1000;
        this.setTimer(countDown(timer));
        let clear = setInterval(()=>{
          --timer;
          if (timer < 0){
            clearInterval(clear);
          }
          let timeObj = countDown(timer);
          this.setTimer(timeObj);
        },1000)
      },
      setTimer(timeObj){
        this.time.days = timeObj._day;
        this.time.hours = timeObj._hours;
        this.time.minutes = timeObj._minutes;
        this.time.seconds = timeObj._seconds;
      },
      goHuichang(){
        location.href = this.adInfo.url;
      }
    },
    components: {}
  }
</script>



// WEBPACK FOOTER //
// src/components/AdArea.vue